import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Image from 'Components/Image';
import s from './ImagePicker.module.scss';

const ImagePicker = ({ images, name, register }) => {

    const sizes = [
        '(min-width: 1440px) 176px',
        '(min-width: 1024px) 20vw',
        '(min-width: 500px) 25vw',
        '50vw',
    ];

    return (
        <div className={s['ImagePicker']}>
            {images.map((image, index) => {
                const { image: imageObj, title, layoutCode } = image;

                return (
                    <div className={s['ImagePicker__Item']} key={index}>
                        <input
                            className={s['ImagePicker__Input']}
                            id={`image-picker-${layoutCode}`}
                            name={name}
                            type="radio"
                            value={layoutCode}
                            defaultChecked={index === 0}
                            {...register}
                        />
                        <label
                            className={s['ImagePicker__Label']}
                            htmlFor={`image-picker-${layoutCode}`}
                        >
                            <div className={s['ImagePicker__Image']}>
                                <Image {...imageObj} sizes={sizes} />
                            </div>

                            {!_.isEmpty(title) ? (
                                <span className={s['ImagePicker__Title']}>{title}</span>
                            ) : (
                                <span className={'sr-only'}>{imageObj.title}</span>
                            )}
                        </label>
                    </div>
                );
            })}
        </div>
    );
};

ImagePicker.propTypes = {
    images: PropTypes.array.isRequired,
    name: PropTypes.string.isRequired,
    register: PropTypes.func,
};

ImagePicker.defaultProps = {
    images: [],
    name: '',
    register: null,
};

export default ImagePicker;
